import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/authStore';

export function useAlertasCount() {
  const token = useAuth((s) => s.token);
  return useQuery({
    queryKey: ['alertas-contador'],
    queryFn: () => api<Record<string, number>>('/alertas/contador'),
    enabled: !!token,
    refetchInterval: 60000,
  });
}
